import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {MonoTypeOperatorFunction, Observable, throwError} from 'rxjs';
import {tap} from 'rxjs/operators';
import {HTTP_STATUS} from '../../common/api-helpers';
import {AuthService} from './auth.service';

export const EXTERNAL_REQUEST_HEADER = 'ExternalRequest';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private authService: AuthService
    ) {}

    public intercept<T>(originalRequest: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
        const isLocalApiRequest: boolean = !originalRequest.headers.get(EXTERNAL_REQUEST_HEADER);

        const request = isLocalApiRequest
            ? this.getAuthRequest(originalRequest)
            : this.deleteRequestHeader(originalRequest, EXTERNAL_REQUEST_HEADER);

        const responsePipe: MonoTypeOperatorFunction<HttpEvent<T>> = isLocalApiRequest
            ? tap({
                error: error => this.handleResponseError(request, error)
            })
            : s$ => s$;

        return next.handle(request).pipe(
            responsePipe
        );
    }

    private getAuthRequest(request: HttpRequest<any>): HttpRequest<any> {
        const headers = this.authService.getAuthHttpHeaders(request.headers);

        return request.clone({headers});
    }

    private deleteRequestHeader(request: HttpRequest<any>, headerName: string): HttpRequest<any> {
        const headers = request.headers.delete(headerName);

        return request.clone({headers});
    }

    private handleResponseError(request: HttpRequest<any>, response: HttpErrorResponse | any): Observable<never> {
        const isHttpError: boolean = response instanceof HttpErrorResponse;
        const doLogout: boolean = isHttpError
            && (response.status === HTTP_STATUS.UNAUTHORIZED || response.status === HTTP_STATUS.FORBIDDEN)
            && !this.isLoginRequest(request)
            && !this.isLogoutRequest(request);

        if (doLogout) {

            // handle authorization errors
            this.authService.innerLogout();
        }

        return throwError(response);
    }

    private isLoginRequest(request: HttpRequest<any>): boolean {
        return Object.values(this.authService.loginApiPathByRoleMap).includes(request.url);
    }

    private isLogoutRequest(request: HttpRequest<any>): boolean {
        return Object.values(this.authService.logoutApiPathByRoleMap).includes(request.url);
    }

}
